import * as $http from './axios';
export const phoneLogin = (data) => {
  return $http.get('/api/oauth/token', data);
};
export const resetP = (data) => {
  return $http.put(`/api/user/reset/pass/${data.userId}`, data);
};
export const UserCheck = (data) => {
  return $http.get(`/api/mobile/check/${data}`);
};
export const phoneLoginPost = (data) => {
  return $http.post('/api/oauth/token', data);
};
export const loginOut = (data) => {
  return $http._delete('/api/token/logout', data);
};
export const getCode = (data) => {
  return $http.get(`/api/mobile/${data}`);
};
export const getPassCode = (data) => {
  return $http.get(`/api/mobile/pass/${data}`);
};
export const getUserinfo = (data) => {
  return $http.get('/api/user/info');
};
export const getUserCheck = (data) => {
  return $http.get('/api/user/extend/check');
};
export const getCertifinfo = (data) => {
  return $http.get(`/api/user/extend/info/${data}`);
};
export const fileUpload = (data) => {
  return new Promise((resolve, reject) => {
    $http.post('/api/sys-file/upload', data).then(res => {
      resolve(res);
    });
  });
};
export const fileUploadunToken = (data) => {
  return new Promise((resolve, reject) => {
    $http.post('/api/sys-file/index/upload', data).then(res => {
      resolve(res);
    });
  });
};
export const sendCertifictaion = (userId, data) => {
  return $http.post(`/api/user/extend/save/${userId}`, data);
};
export const upDateCertifictaion = (userId, data) => {
  return $http.put(`/api/user/extend/update/${userId}`, data);
};

// 权力接口
export const creatPower = (data) => {
  return $http.post('/api/series/save', data);
};
export const getPowerList = (data) => {
  return $http.get('/api/series/page', data);
};
export const getPowerDetail = (data) => {
  return $http.get(`/api/series/get/${data}`);
};
export const seriesUpdateSort = (data) => {
  return $http.put('/api/series/updateSort', data);
};
export const seriesSetUp = (data) => {
  return $http.put('/api/series/setTop', data);
};
export const updatePowerName = (data) => {
  return $http.put('/api/series/update', data);
};
export const delPower = (data) => {
  return $http._delete(`/api/series/delete/${data}`, data);
};

// 侵权接口
export const creatTort = (data) => {
  return $http.post('/api/evidencebag/save', data);
};
export const getTortList = (data) => {
  return $http.get('/api/evidencebag/page', data);
};
export const tortUpdateSort = (data) => {
  return $http.put('/api/evidencebag/updateSort', data);
};
export const updateTortName = (data) => {
  return $http.put('/api/evidencebag/update', data);
};
export const resetTortCode = (data) => {
  return $http.put('/api/evidencebag/updateCode', data);
};
export const lockTort = (data) => {
  return $http.put('/api/evidencebag/updateLock', data);
};
export const delTort = (data) => {
  return $http._delete(`/api/evidencebag/delete/${data}`, data);
};

// 权力详情

export const getPowerDetailList = (data) => {
  return $http.get('/api/work/page', data);
};

export const PowerDetailDel = (data) => {
  return $http._delete(`/api/work/delete/${data}`);
};
export const PowerDetailSort = (data) => {
  return $http.put('/api/work/update', data);
};
export const workDetailSetTop = (data) => {
  return $http.put('/api/work/setTop', data);
};

// 新增存证

export const powerSave = (data) => {
  return $http.post('/api/work/save', data);
};
export const powerUpdate = (data) => {
  return $http.post('/api/work/update/info', data);
};

export const clothUpload = (data) => {
  return new Promise((resolve, reject) => {
    $http.post('/api/sys-file/uploadFile', data).then(res => {
      resolve(res);
    });
  });
};
export const getAiTips = (data) => {
  return new Promise((resolve, reject) => {
    $http.get(`/api/sys-file/getPicTags/${data}`).then(res => {
      resolve(res);
    });
  });
};
export const addNewTips = (data) => {
  return $http.post('/api/usertag/save', data);
};
export const getTipsList = (data) => {
  return $http.get('/api/usertag/get/type', data);
};

// 商标接口
export const brandList = (data) => {
  return $http.get('/api/workuserbrand/page', data);
};

export const brandAdd = (data) => {
  return $http.post('/api/workuserbrand/save', data);
};

export const brandlDel = (data) => {
  return $http._delete(`/api/workuserbrand/delete/${data}`);
};

// 存证详情
export const tortDetail = (data) => {
  return $http.get(`/api/work/get/${data}`);
};
export const tortCodeList = (data) => {
  return $http.get('/api/workcode/page', data);
};
export const tortPublish = (data) => {
  return $http.put('/api/work/publish', data);
};
export const tortCodeAdd = (data) => {
  return $http.put('/api/workcode/update', data);
};
export const tortCodeCreat = (data) => {
  return $http.post('/api/workcode/save', data);
};
export const tortCodeDelet = (data) => {
  return $http._delete(`/api/workcode/delete/${data}`);
};
export const codeDownload = (data) => {
  return $http.post('/api/workcode/down/code', data);
};
export const codeDownloadZip = (data) => {
  return $http.post('/api/workcode/down/code/zip', data);
};
export const fileDownload = (url, data) => {
  return $http.post(url, data, { responseType: 'blob' });
};

// 取证详情
export const tortPageDetail = (data) => {
  return $http.get(`/api/evidencebag/get/${data}`);
};
export const tortGetBycode = (data) => {
  return $http.get('/api/evidencetake/getTakeInfo', data);
};
export const tortTabelList = (data) => {
  return $http.get('/api/evidencetort/page', data);
};
export const synthesisTabelList = (data) => {
  return $http.get('/api/evidencesynthesis/page', data);
};
export const tortPageAdd = (data) => {
  return $http.put('/api/evidencebag/relation/work', data);
};
export const tortconfirm = (data) => {
  return $http.put('/api/evidencetort/confirm/tort', data);
};
export const tortTabelAdd = (data) => {
  return $http.post('/api/evidencetort/save', data);
};
export const synthesisTabelAdd = (data) => {
  return $http.post('/api/evidencesynthesis/save', data);
};
export const tortTabelDel = (data) => {
  return $http._delete(`/api/evidencetort/delete/${data}`);
};
export const synthesisTabelDel = (data) => {
  return $http._delete(`/api/evidencesynthesis/delete/${data}`);
};

// 用户存证列表
export const UserPowerList = (data) => {
  return $http.get('/api/series/list', data);
};
export const UserTortList = (data) => {
  return $http.get('/api/work/list', data);
};

// 刊物列表

export const ProductList = (data) => {
  return $http.get('/api/work/index/page', data);
};
export const ProductDetail = (data) => {
  return $http.get(`/api/work/index/get/${data}`);
};

// 作品故事
export const StoryGet = (data) => {
  return $http.get(`/api/workstory/get/${data}`);
};
export const StoryUpadte = (data) => {
  return $http.put('/api/workstory/update', data);
};
export const StoryAdd = (data) => {
  return $http.post('/api/workstory/save', data);
};

// 获取协会证书内容
export const depositeCertificateInfo = (data) => {
  return $http.get(`/api/work/certification/get/${data}`);
};
// 下载公证处证书
export const notaryDownload = (data) => {
  return $http.get(`/api/work/down/certificate/file/${data}`);
};
// 获取侵权证书内容
export const tortCertificateInfo = (data) => {
  return $http.get(`/api/evidencetort/certification/tort/${data}`);
};
// 下载营业执照
export const userCertificateDownload = (data) => {
  return $http.get(`/api/user/extend/down/file/${data}`);
};
// 下载综合证物（单个）
export const DownloadExhbitOne = (data) => {
  return $http.get(`/api/evidencesynthesis/down/synthesis/${data}`);
};

// ==========================================v2.5 START===============================================

// 获取网站配置（单个）
export const fetchSettingOne = () => {
  return $http.get(`/api/setting/get`);
};

// 获取用户余额（单个）
export const fetchUserBalance = (userId) => {
  return $http.get(`/api/fa/user/get/user/balance/${userId}`);
};

// 获取用户套餐（多个）
export const fetchUserLicense = (userId) => {
  return $http.get(`/api/fa/user/get/license/list/${userId}`);
};

// 获取用户账单列表
export const getUserConsumeList = (userId, data) => {
  return $http.get(`/api/fa/user/get/user/consume/list/${userId}`, data);
};

// 获取用户可开票金额
export const fetchUserInvoiceAmount = (userId) => {
  return $http.get(`/api/fa/user/get/user/invoice/amount/${userId}`);
};

// 获取用户可开票记录
export const fetchUserInvoiceList = (userId, data) => {
  return $http.get(`/api/fa/user/get/user/invoice/list/${userId}`, data);
};

// 获取用户待开票记录
export const fetchUserWaitInvoiceList = (userId, data) => {
  return $http.get(`/api/fa/user/get/user/invoice/wait/list/${userId}`, data);
};

// 提交开票申请
export const fetchApplyInvoice = (data) => {
  return $http.post(`/api/fa/user/do/apply/invoice`, data);
};

// 获取用户待开票记录
export const fetchUserInvoiceDetail = (id, data) => {
  return $http.get(`/api/fa/user/get/user/invoice/detail/${id}`, data);
};

// 查询系统套餐
export const fetchAllLicense = () => {
  return $http.get(`/api/licnse/client/list`);
};

// 查询用户套餐
export const fetchUserLicenses = (id) => {
  return $http.get(`/api/fa/user/get/user/license/${id}`);
};

// 充值汇款
export const fetchSaveCharge = (data) => {
  return $http.post('/api/b-order/client/save', data);
};

export const fetchPDFPage = (query) => {
  return $http.get('/api/invoice/pdf/page', query);
};

export const fetchRefresh = (query) => {
  return $http.get('/api/user/extend/refresh/' + query);
};
// ==========================================v2.5 END=================================================

// ==========================================v2.6 START===============================================

// 获取我的模板
export const templateList = () => {
  return $http.get(`/api/template/list`);
};

// 新增模板
export const templateAdd = (data) => {
  return $http.post(`/api/template/save`, data);
};

// 修改模板
export const templateUpdate = (data) => {
  return $http.put(`/api/template/update`, data);
};

// 获取版权码列表
export const templateCodeList = (workCodeId) => {
  return $http.get(`/api/template/code/${workCodeId}`);
};

export const templateDelete = (data) => {
  return $http._delete(`/api/template/delete/${data}`, data);
};

// 设计完成接口
export const templateCodeSubmit = (data) => {
  return $http.post(`/api/template/code/submit`, data);
};

// 预览接口
export const templateCodePreview = (data) => {
  return $http.post(`/api/template/code/preview`, data);
};

// ==========================================v2.6 END=================================================
// ==========================================v2.7 START===============================================
export const getAreaTree = () => {
  return $http.get(`/api/sys-file/get/area`);
};
// 处置内容-第一步保存
export const fetchSafeSave = (data) => {
  return $http.post(`/api/fastequityinfo/user/save`, data);
};
// 根据ID查询第一步内容
export const fetchSafeById = (id) => {
  return $http.get(`/api/fastequityinfo/user/get/${id}`);
};
// 处置内容-第一步保存
export const fetchSafeSaveUser = (data) => {
  return $http.post(`/api/fastequityuser/user/save`, data);
};
// 根据ID查询第一步内容
export const fetchSafeUserById = (id) => {
  return $http.get(`/api/fastequityuser/user/get/${id}`);
};
// 处置提交
export const fetchSafeUpdate = (data) => {
  return $http.put(`/api/fastequityinfo/submit`, data);
};
// 处置内容-第一步-权益材料-系列列表
export const fetchFastList = (query) => {
  return $http.get(`/api/series/fast/list`, query);
}
// 处置内容-第一步-补充权益材料-系列列表
export const fetchSupFastList = (query) => {
  return $http.get(`/api/fastequityinfo/user/dh/evi/list`, query);
}
export const fetchSupFileFastList = (query) => {
  return $http.get(`/api/fastequityinfo/user/dh/evi/source/list`, query);
}
// 列表-处置内容-进度查看
export const fetchProcessList = (query) => {
  return $http.get(`/api/fastequityauditrecord/user/list`, query);
}
// 维权分页
export const fetchSafePage = (query) => {
  return $http.get(`/api/fastequityinfo/user/page`, query);
}
// 确认提交
export const fetchSafeSubmit = (data) => {
  return $http.put(`/api/fastequityinfo/submit`, data);
}
// ==========================================v2.7 END=================================================
// ==========================================系列密码、多平台发证=================================================
// 系列设置密码
export const fetchSeriesPwd = (data) => {
  return $http.put(`/api/series/setPassword`, data);
}

// 系列设置密码
export const fetchSeriesClearPwd = (data) => {
  return $http.put(`/api/series/clearPassword`, data);
}

// 系列设置密码
export const fetchSeriesSendCode = (phone) => {
  return $http.put(`/api/series/send/code/${phone}`);
}

// 验证密码
export const fetchSeriesCheckPwd = (data) => {
  return $http.put(`/api/series/checkPassword`, data);
}
// 验证密码
export const fetchSeriesCachePwd = (data) => {
  return $http.put(`/api/series/cache/password`, data);
}
// 获取默认配置
export const fetchDefaultSetting = (query) => {
  return $http.get(`/api/default/setting/get`, query);
}
// 获取默认配置
export const fetchDefaultUpdate = (data) => {
  return $http.put(`/api/default/setting/update`, data);
}
// 获取默认配置
export const fetchClearCache = () => {
  return $http.put(`/api/series/clear/cache/all`);
}
// ==========================================系列密码、多平台发证=================================================



// WEBPACK FOOTER //
// ./src/api/index.js